import { Tooltip } from 'antd/lib';
import React from 'react';
import Certain from '../../../../../../../components/Operation/Certain';
import OperationStatus from '../../../../../../../components/Operation/OperationStatus';
import { datetime } from "../../../../../../../util/library/datetime";
import {
    OP_STATUS,
    SHORT_DATETIME_FORMAT,
    timeLate
} from "../../../../../../../util/varibles/constants";
import { durationTxt, getStepNameOfOp } from "../../../../../../../util/varibles/global";
import { TOperation } from "../../../../../../../util/varibles/interface";
import styles from "../style.module.scss";

const Description: React.FC<IProps> = (props) => {
    const { operation, activityLog, isOld = false } = props;
    const { status, operation_type, current_process = 0 } = operation;

    switch (status) {
        case OP_STATUS.APPROVED: {
            const { eta = 0, est_start_time } = activityLog[0];
            const time = datetime(eta || est_start_time).format(SHORT_DATETIME_FORMAT);
            const getName = getStepNameOfOp[operation_type] || getStepNameOfOp.default;
            const stateTxt = getName({
                current_process: 0,
                operation,
                activity_log: activityLog, isOld
            });
            let delayTime = eta ? est_start_time - eta : 0;

            return <div className={styles['operation-status']}>
                <div className="whitespace-nowrap">
                    Will be
                    <span className="font-w4 mx-1" >{stateTxt}</span>
                    on <span className='font-w4'>{time}</span>
                </div>
                <div className="whitespace-nowrap">
                    <span>
                        Planned:
                        <span className='font-w4 ml-[5px]'>
                            {datetime(est_start_time).format(SHORT_DATETIME_FORMAT)}
                        </span>
                    </span>
                    {Math.abs(delayTime) > timeLate && <span className='font-w4' data-late-state={delayTime > 0}>
                        (diff {durationTxt(delayTime)})
                    </span>}
                </div>
            </div>;
        }
        case OP_STATUS.PROCESSING: {
            const { eta = 0, est_start_time } = activityLog[current_process + 1] || {};
            const time = datetime(eta || est_start_time).format(SHORT_DATETIME_FORMAT);
            const getName = getStepNameOfOp[operation_type] || getStepNameOfOp.default;
            const stateTxt = getName({
                current_process: current_process + 1,
                operation: props.operation,
                activity_log: activityLog,
                isOld
            });
            let delayTime = eta ? est_start_time - eta : 0;
            return <div className={styles['operation-status']}>
                <div className="whitespace-nowrap">
                    Will be
                    <span className="font-w4 mx-1">{stateTxt}</span>
                    on <span className='font-w4'>{time}</span>
                </div>
                <div className="whitespace-nowrap">
                    <span>
                        Planned:
                        <span className='font-w4 ml-[5px]'>
                            {datetime(est_start_time).format(SHORT_DATETIME_FORMAT)}
                        </span>
                    </span>
                    {Math.abs(delayTime) > timeLate && <span className='font-w4' data-late-state={delayTime > 0}>
                        (diff {durationTxt(delayTime)})
                    </span>}
                </div>
            </div>;
        }
        case OP_STATUS.FINISHED: {
            const { real_start_time, est_start_time } = activityLog[activityLog.length - 1];
            const time = datetime(real_start_time).format(SHORT_DATETIME_FORMAT);
            const delayTime = est_start_time - real_start_time;
            const finalStatus = `${durationTxt(delayTime)} ${delayTime > 0 ? 'before schedule' : 'behind schedule'}`
            return <div className={styles['operation-status']}>
                <div className="whitespace-nowrap">
                    Will be
                    <span className="font-w4 mx-1">Completed</span>
                    on <span className='font-w4'>{time}</span>
                </div>
                <div className="whitespace-nowrap">
                    {Math.abs(delayTime) > timeLate ? <span className='font-w4' data-late-state={delayTime > 0}>
                        {finalStatus}
                    </span> : <span className='font-w4' data-late-state={true}>On time</span>}
                </div>
            </div>
        }
        default:
            return null;
    }
}

interface IProps {
    operation: TOperation
    activityLog: any
    isOld?: boolean
    realStatus?: OP_STATUS
}

const Status: React.FC<IProps> = (props) => {
    const { status } = props.operation;
    const { realStatus } = props;

    return <>
        <Tooltip title={<Description {...props} />} >
            <div>
                <OperationStatus status={realStatus || status} />
            </div>
        </Tooltip>
        <Certain operation={props.operation} status={status} />
    </>;
}

export default Status;
